import { Navbar } from "components/ui/shared/Navbar";
import { Outlet } from "react-router-dom";
import styled from "styled-components";

export const AppLayout = () => {

    return (
        <StyledAppLayout>
            <Navbar/>
            <Main>
                <Outlet/>
            </Main>
            
        </StyledAppLayout>
    )
}

const StyledAppLayout = styled.div`
    height: 100%;
    width: 100%;
    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: row;
`

const Main = styled.main`
    height: 100%;
    flex: 1 1 auto;
    overflow: hidden;
    padding-bottom: ${({theme}) => theme.spacing.md};
    position: relative;
    display: flex;
    flex-direction: column;
`